import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.drive');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-drive',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.drive/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
}

.drive-shell {
  position: relative;
}

.drive-main-content {
  min-width: 0;
}

.drive-preview-panel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  width: clamp(320px, 42vw, 620px);
  min-width: 0;
  background: #ffffff;
  border: 0.5px solid #cbd5e1;
  border-right: 0;
  box-shadow: -8px 0 24px rgba(15, 23, 42, 0.14);
}

.drive-shell-retro .drive-preview-panel {
  border-color: #999999;
  border-right: 0;
  border-left-width: 0.5px;
  box-shadow: -6px 0 18px rgba(0, 0, 0, 0.18);
}

.drive-preview-panel iframe {
  border-top: 0.5px solid #e2e8f0 !important;
}

.drive-shell-retro .drive-preview-panel iframe {
  border-top-color: #cccccc !important;
}

@media (max-width: 860px) {
  .drive-preview-panel {
    left: 0;
    width: 100%;
  }
}
@media (max-width: 767px) {
  .drive-shell {
    min-width: 0;
    overflow: hidden;
  }
  .drive-shell .drive-header {
    align-items: stretch !important;
    flex-direction: column;
    gap: 8px;
    padding: 8px !important;
  }
  .drive-shell .drive-title-search {
    flex-wrap: wrap;
    gap: 6px !important;
    width: 100%;
  }
  .drive-shell .drive-search {
    flex: 1 1 180px;
    width: 100%;
    max-width: none !important;
    margin-left: 0 !important;
  }
  .drive-shell .drive-actions {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .drive-shell .drive-actions::-webkit-scrollbar {
    display: none;
  }
  .drive-shell .drive-actions button {
    flex: 0 0 auto;
    min-height: 30px;
    padding: 4px 8px !important;
    font-size: 11px !important;
    white-space: nowrap;
  }
  .drive-shell .drive-service-meta,
  .drive-shell .drive-breadcrumb,
  .drive-shell .drive-summary,
  .drive-shell .drive-new-folder {
    flex-wrap: wrap;
    gap: 5px !important;
    padding: 6px 8px !important;
  }
  .drive-shell .drive-breadcrumb > div:first-child {
    min-width: 0;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .drive-shell .drive-breadcrumb > div:first-child::-webkit-scrollbar {
    display: none;
  }
  .drive-shell .drive-breadcrumb button,
  .drive-shell .drive-new-folder button,
  .drive-shell .drive-new-folder span {
    white-space: nowrap;
  }
  .drive-shell .drive-new-folder input {
    flex: 1 1 160px;
    width: auto !important;
    min-width: 0;
  }
  .drive-main-content {
    overflow-x: hidden !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
  }
  .drive-table-wrap {
    margin: 10px !important;
    border-radius: 8px !important;
  }
  .drive-preview-panel {
    left: 0;
    width: 100% !important;
    max-width: none;
    box-shadow: none;
  }
  .drive-preview-panel > div:first-child {
    flex-wrap: wrap;
    padding: 8px !important;
  }
  .drive-shell-retro {
    min-width: 0;
    overflow: hidden;
  }
  .drive-shell-retro .drive-retro-header {
    align-items: stretch !important;
    flex-direction: column;
    gap: 6px;
    padding: 8px !important;
  }
  .drive-shell-retro .drive-retro-title-search {
    flex-wrap: wrap;
    gap: 6px !important;
    width: 100%;
  }
  .drive-shell-retro .drive-retro-search {
    flex: 1 1 180px;
    width: 100%;
    max-width: none !important;
    margin-left: 0 !important;
  }
  .drive-shell-retro .drive-retro-actions {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .drive-shell-retro .drive-retro-actions::-webkit-scrollbar {
    display: none;
  }
  .drive-shell-retro .drive-retro-actions button {
    flex: 0 0 auto;
    padding: 4px 8px !important;
    font-size: 11px !important;
    white-space: nowrap;
  }
  .drive-shell-retro .drive-retro-service-meta,
  .drive-shell-retro .drive-retro-breadcrumb,
  .drive-shell-retro .drive-retro-summary,
  .drive-shell-retro .drive-retro-new-folder {
    flex-wrap: wrap;
    gap: 5px !important;
    padding: 6px 8px !important;
  }
  .drive-shell-retro .drive-retro-breadcrumb > div:first-child {
    min-width: 0;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .drive-shell-retro .drive-retro-breadcrumb > div:first-child::-webkit-scrollbar {
    display: none;
  }
  .drive-shell-retro .drive-retro-breadcrumb button,
  .drive-shell-retro .drive-retro-new-folder button,
  .drive-shell-retro .drive-retro-new-folder span {
    white-space: nowrap;
  }
  .drive-shell-retro .drive-retro-new-folder input {
    flex: 1 1 160px;
    width: auto !important;
    min-width: 0;
  }
  .drive-shell-retro .drive-main-content {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  .drive-shell-retro table {
    min-width: 720px;
  }
  .drive-shell-retro input,
  .drive-shell-retro select,
  .drive-shell-retro textarea,
  .drive-shell-retro button {
    max-width: 100%;
  }
  .drive-file-table,
  .drive-file-table tbody,
  .drive-file-table tr,
  .drive-file-table td,
  .drive-metadata-table,
  .drive-metadata-table tbody,
  .drive-metadata-table tr,
  .drive-metadata-table td {
    display: block;
    width: 100%;
    box-sizing: border-box;
  }
  .drive-file-table,
  .drive-metadata-table {
    min-width: 0 !important;
    table-layout: auto !important;
  }
  .drive-file-table thead,
  .drive-metadata-table thead {
    display: none;
  }
  .drive-file-table tr {
    position: relative;
    min-height: 68px;
    padding: 10px 10px 10px 42px;
    border-bottom: 1px solid #e5e7eb !important;
    background: #ffffff;
  }
  .drive-file-table tr:last-child {
    border-bottom: 0 !important;
  }
  .drive-file-table td {
    padding: 0 !important;
    border: 0 !important;
    text-align: left !important;
  }
  .drive-file-table td:first-child {
    position: absolute;
    top: 12px;
    left: 10px;
    width: 24px;
    text-align: center !important;
  }
  .drive-file-table td:nth-child(2) {
    min-width: 0;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.35;
  }
  .drive-file-table .truncate {
    overflow: visible !important;
    text-overflow: clip !important;
    white-space: normal !important;
    word-break: break-word;
  }
  .drive-file-table td:nth-child(2) div {
    min-width: 0;
  }
  .drive-file-table td:nth-child(2) div[style*="display: flex"] {
    flex-wrap: wrap;
  }
  .drive-file-table td:nth-child(2) [style*="white-space: nowrap"] {
    overflow: visible !important;
    text-overflow: clip !important;
    white-space: normal !important;
    word-break: break-word;
  }
  .drive-file-table td:not(:first-child):not(:nth-child(2)):not(:last-child) {
    display: inline-flex;
    align-items: center;
    width: auto;
    margin-top: 5px;
    margin-right: 8px;
    color: #64748b !important;
    font-size: 10px;
    line-height: 1.3;
    vertical-align: top;
  }
  .drive-file-table td:last-child {
    margin-top: 8px;
  }
  .drive-file-table td:last-child > div {
    justify-content: flex-start !important;
    flex-wrap: wrap;
    gap: 6px !important;
    white-space: normal !important;
  }
  .drive-file-table td:last-child button {
    min-height: 26px;
    padding: 2px 6px !important;
    line-height: 1.2;
  }
  .drive-file-table .drive-cell-kind {
    position: absolute;
    top: 12px;
    left: 10px;
    width: 24px !important;
    text-align: center !important;
  }
  .drive-file-table .drive-cell-name {
    display: block !important;
    min-width: 0;
    color: #0f172a !important;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.35;
  }
  .drive-file-table .drive-cell-name::before,
  .drive-file-table .drive-cell-size::before,
  .drive-file-table .drive-cell-role::before,
  .drive-file-table .drive-cell-updated::before {
    color: #94a3b8;
    font-size: 10px;
    font-weight: 700;
    line-height: 1.2;
  }
  .drive-file-table .drive-cell-name::before {
    content: "이름";
    display: block;
    margin-bottom: 2px;
  }
  .drive-file-table .drive-cell-name .truncate,
  .drive-file-table .drive-cell-name [style*="white-space: nowrap"] {
    display: inline !important;
    overflow: visible !important;
    text-overflow: clip !important;
    white-space: normal !important;
    word-break: break-word;
  }
  .drive-file-table .drive-cell-size,
  .drive-file-table .drive-cell-role,
  .drive-file-table .drive-cell-updated {
    display: inline-flex !important;
    align-items: center;
    width: auto !important;
    margin-top: 7px;
    margin-right: 9px;
    color: #475569 !important;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.3;
  }
  .drive-file-table .drive-cell-size::before {
    content: "크기";
    margin-right: 4px;
  }
  .drive-file-table .drive-cell-role::before {
    content: "역할";
    margin-right: 4px;
  }
  .drive-file-table .drive-cell-updated::before {
    content: "수정";
    margin-right: 4px;
  }
  .drive-file-table .drive-cell-actions {
    display: block !important;
    width: 100% !important;
    margin-top: 9px;
  }
  .drive-metadata-table tr {
    padding: 9px 10px;
    border-bottom: 1px solid #e5e7eb !important;
    background: #ffffff;
  }
  .drive-metadata-table tr:last-child {
    border-bottom: 0 !important;
  }
  .drive-metadata-table td {
    padding: 3px 0 !important;
    border: 0 !important;
    text-align: left !important;
    overflow-wrap: anywhere;
  }
  .drive-metadata-table td::before {
    display: inline-block;
    min-width: 42px;
    margin-right: 6px;
    color: #94a3b8;
    font-size: 10px;
    font-weight: 700;
  }
  .drive-metadata-table td:nth-child(1)::before {
    content: "역할";
  }
  .drive-metadata-table td:nth-child(2)::before {
    content: "파일";
  }
  .drive-metadata-table td:nth-child(3)::before {
    content: "설명";
  }
  .drive-metadata-table td:nth-child(4)::before {
    content: "변경";
  }
}
.legacy-roomy-controls .roomy-button,
.legacy-roomy-controls td > button {
  box-sizing: border-box;
  min-height: 22px;
  padding: 3px 9px !important;
  line-height: 1.35;
}
.legacy-roomy-controls .roomy-badge,
.legacy-roomy-controls td > span {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 2px 7px !important;
  line-height: 1.35;
}

[draggable=true] {
  cursor: grab;
}

[draggable=true]:active {
  cursor: grabbing;
}

.drive-dragging {
  opacity: 0.45;
}

.drive-drop-target {
  outline: 2px solid #6366f1;
  outline-offset: -2px;
  background: #eef2ff !important;
}`],
})
export class PageDriveComponent implements OnInit {
    public folders: any[] = [];
    public files: any[] = [];
    public currentFolder: string = '';
    public breadcrumb: any[] = [];
    public fileCount: number = 0;
    public page: number = 1;
    public dump: number = 50;
    public searchText: string = '';

    // UI state
    public newFolderName: string = '';
    public showNewFolder: boolean = false;
    public creatingFolder: boolean = false;
    public editingId: string = '';
    public editingName: string = '';
    public selectedItems: Set<string> = new Set();
    public selectedItem: string = '';
    public selectMode: boolean = false;
    public creatingInspection: boolean = false;
    public creatingDataset: boolean = false;
    public draggingItem: any = null;
    public dragOverFolderId: string = '';
    public movingItem: boolean = false;
    private driveDragMime: string = 'application/x-wiz-drive-item';
    public previewFile: any = null;
    public previewUrl: string = '';
    public showInspectionSelector: boolean = false;
    public inspectionCandidates: any[] = [];
    public inspectionSelection: any = {};
    public inspectionCandidatePolicy: any = null;

    // 업로드 진행 상태
    public uploading: boolean = false;
    public uploadProgress: string = '';
    public uploadPercent: number = 0;

    // 메타데이터
    public metadata: any = null;
    public generatingMeta: boolean = false;
    public showMetaPanel: boolean = false;
    public metaProgress: string = '';
    public metaPercent: number = 0;
    public bulkMetadataRole: string = 'report';
    public readonly metadataRoleOptions: any[] = [
        { role: 'report', label: '보고서' },
        { role: '부록', label: '부록' },
        { role: 'contract', label: '계약서' },
        { role: 'kickoff', label: '착수계' },
        { role: 'ledger', label: '관리대장' },
        { role: 'other', label: '기타' },
    ];

    // 용역명
    public serviceName: string = '';
    public editingServiceName: boolean = false;

    // 설정
    public autoClassify: boolean = true;

    // 테마
    public theme: string = 'modern';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.theme = localStorage.getItem('ui-theme') || 'modern';
        // 드라이브 설정 로드
        try {
            const settingsRes: any = await wiz.call("get_drive_settings");
            if (settingsRes.code === 200) {
                this.autoClassify = settingsRes.data.drive_auto_classify !== false;
            }
        } catch (e) { }
        await this.load();
    }

    public async load() {
        let res: any = await wiz.call("list", {
            folder_id: this.currentFolder,
            page: this.page,
            dump: this.dump,
            text: this.searchText
        });
        if (res.code === 200) {
            this.folders = res.data.folders || [];
            this.files = res.data.files || [];
            this.fileCount = res.data.file_count || 0;
            this.breadcrumb = res.data.breadcrumb || [];
            this.currentFolder = res.data.current_folder || '';
            this.metadata = res.data.metadata || null;
            this.serviceName = this.metadata?.service_name || '';
        }
        this.selectedItems.clear();
        this.selectedItem = '';
        await this.service.render();
    }

    public async openFolder(folderId: string) {
        this.closePreview();
        this._resetInspectionSelector();
        this.currentFolder = folderId;
        this.page = 1;
        this.searchText = '';
        this.showMetaPanel = false;
        this.editingServiceName = false;
        await this.load();
    }

    public async goRoot() {
        this.closePreview();
        this._resetInspectionSelector();
        this.currentFolder = '';
        this.page = 1;
        this.searchText = '';
        this.metadata = null;
        this.showMetaPanel = false;
        this.serviceName = '';
        this.editingServiceName = false;
        await this.load();
    }

    public async navigateBreadcrumb(folderId: string) {
        this.closePreview();
        this._resetInspectionSelector();
        this.currentFolder = folderId;
        this.page = 1;
        this.showMetaPanel = false;
        this.editingServiceName = false;
        await this.load();
    }

    // ── 선택 모드 ──

    public async toggleSelectMode() {
        this.selectMode = !this.selectMode;
        if (!this.selectMode) {
            this.selectedItems.clear();
        }
        await this.service.render();
    }

    // ── 용역명 ──

    public async startEditServiceName() {
        this.editingServiceName = true;
        await this.service.render();
    }

    public async saveServiceName() {
        if (!this.currentFolder) return;
        await wiz.call("save_service_name", {
            folder_id: this.currentFolder,
            service_name: this.serviceName
        });
        this.editingServiceName = false;
        if (this.metadata) {
            this.metadata.service_name = this.serviceName;
        }
        await this.service.render();
    }

    public async cancelEditServiceName() {
        this.serviceName = this.metadata?.service_name || '';
        this.editingServiceName = false;
        await this.service.render();
    }

    // ── 폴더 CRUD ──

    public async toggleNewFolder() {
        this.showNewFolder = !this.showNewFolder;
        this.newFolderName = '';
        await this.service.render();
    }

    public async createFolder() {
        if (this.creatingFolder) return;
        if (!this.newFolderName.trim()) return;
        this.creatingFolder = true;
        await this.service.render();
        try {
            let res: any = await wiz.call("create_folder", {
                name: this.newFolderName.trim(),
                parent_id: this.currentFolder
            });
            if (res.code === 200) {
                this.showNewFolder = false;
                this.newFolderName = '';
                await this.load();
            } else {
                await this._showDriveError('폴더 생성 실패', this.getResponseMessage(res, '폴더를 만들지 못했습니다.'));
            }
        } catch (e) {
            await this._showDriveError('폴더 생성 실패', this.getErrorMessage(e, '폴더를 만들지 못했습니다.'));
        } finally {
            this.creatingFolder = false;
            await this.service.render();
        }
    }

    public async startRename(item: any, type: string) {
        this.editingId = type + ':' + item.id;
        this.editingName = item.name;
        await this.service.render();
    }

    public async confirmRename(item: any, type: string) {
        if (!this.editingName.trim()) return;
        if (type === 'folder') {
            await wiz.call("rename_folder", { folder_id: item.id, name: this.editingName.trim() });
        } else {
            await wiz.call("rename_file", { file_id: item.id, name: this.editingName.trim() });
        }
        this.editingId = '';
        await this.load();
    }

    public cancelRename() {
        this.editingId = '';
    }

    // ── 상위 폴더 이동 ──

    public async goUp() {
        if (this.breadcrumb.length > 1) {
            const parentId = this.breadcrumb[this.breadcrumb.length - 2].id;
            await this.openFolder(parentId);
        } else {
            await this.goRoot();
        }
    }

    // ── 행 선택 (단일 클릭 하이라이트) ──

    public async selectRow(key: string) {
        this.selectedItem = this.selectedItem === key ? '' : key;
        await this.service.render();
    }

    // ── 체크박스 선택 ──

    public async toggleCheck(key: string, event: any) {
        event.stopPropagation();
        if (this.selectedItems.has(key)) {
            this.selectedItems.delete(key);
        } else {
            this.selectedItems.add(key);
        }
        await this.service.render();
    }

    public async toggleCheckAll() {
        if (this.isAllChecked) {
            this.selectedItems.clear();
        } else {
            for (const f of this.folders) this.selectedItems.add('folder:' + f.id);
            for (const f of this.files) this.selectedItems.add('file:' + f.id);
        }
        await this.service.render();
    }

    public get isAllChecked(): boolean {
        const total = this.folders.length + this.files.length;
        return total > 0 && this.selectedItems.size === total;
    }

    // ── 일괄 삭제 ──

    public async bulkDelete() {
        const count = this.selectedItems.size;
        if (count === 0) return;
        let res = await this.service.modal.show({
            title: "선택 항목 삭제",
            message: `선택한 ${count}개 항목을 삭제하시겠습니까?`,
            action: "삭제",
            actionBtn: "error"
        });
        if (!res) return;
        for (const key of Array.from(this.selectedItems)) {
            const idx = key.indexOf(':');
            const type = key.substring(0, idx);
            const id = key.substring(idx + 1);
            if (type === 'folder') {
                await wiz.call("delete_folder", { folder_id: id });
            } else {
                await wiz.call("delete_file", { file_id: id });
            }
        }
        this.selectedItems.clear();
        await this.load();
    }

    public async deleteFolder(folderId: string) {
        let res = await this.service.modal.show({ title: "폴더 삭제", message: "이 폴더와 하위 항목이 모두 삭제됩니다.", action: "삭제", actionBtn: "error" });
        if (!res) return;
        await wiz.call("delete_folder", { folder_id: folderId });
        await this.load();
    }

    // ── 업로드 ──

    private async _uploadWithProgress(fd: FormData, label: string = '', folderId: string = ''): Promise<any> {
        const self = this;
        const action = `upload?folder_id=${encodeURIComponent(folderId || '')}`;
        const res: any = await wiz.call(action, fd, {
            contentType: false,
            processData: false,
            xhr: function () {
                const xhr = new XMLHttpRequest();
                xhr.upload.onprogress = (e: ProgressEvent) => {
                    if (e.lengthComputable) {
                        self.uploadPercent = Math.round((e.loaded / e.total) * 100);
                        const loaded = self.formatSize(e.loaded);
                        const total = self.formatSize(e.total);
                        self.uploadProgress = label
                            ? `${label} — ${loaded} / ${total} (${self.uploadPercent}%)`
                            : `${loaded} / ${total} (${self.uploadPercent}%)`;
                        self.service.render();
                    }
                };
                return xhr;
            }
        });
        if (res?.code !== 200) {
            throw new Error(this.getResponseMessage(res, '파일 업로드에 실패했습니다.'));
        }
        return res;
    }

    private _resetUploadState() {
        this.uploading = false;
        this.uploadProgress = '';
        this.uploadPercent = 0;
    }

    private async _showDriveError(title: string, message: string) {
        await this.service.modal.show({
            title,
            message,
            action: '확인',
            cancel: false,
            status: 'error',
            actionBtn: 'error',
        });
    }

    private _uploadedIds(res: any): string[] {
        const ids = res?.data?.ids;
        return Array.isArray(ids) ? ids.filter((id: string) => !!id) : [];
    }

    private async _rollbackCreatedUpload(createdFolders: any[], uploadedFileIds: string[]): Promise<string[]> {
        const failures: string[] = [];
        const folderSeen = new Set<string>();
        const fileSeen = new Set<string>();

        for (const fileId of uploadedFileIds) {
            if (!fileId || fileSeen.has(fileId)) continue;
            fileSeen.add(fileId);
            try {
                const res: any = await wiz.call('delete_file', { file_id: fileId });
                if (res?.code !== 200) failures.push(fileId);
            } catch (e) {
                failures.push(fileId);
            }
        }

        for (const folder of [...createdFolders].reverse()) {
            const folderId = folder?.id;
            if (!folderId || folderSeen.has(folderId)) continue;
            folderSeen.add(folderId);
            try {
                const res: any = await wiz.call('delete_folder', { folder_id: folderId });
                if (res?.code !== 200) {
                    failures.push(folder?.path || folder?.name || folderId);
                }
            } catch (e) {
                failures.push(folder?.path || folder?.name || folderId);
            }
        }

        return failures;
    }

    private _cleanupMessage(createdFolders: any[], uploadedFileIds: string[], cleanupFailures: string[]): string {
        if (createdFolders.length === 0 && uploadedFileIds.length === 0) return '';
        if (cleanupFailures.length > 0) {
            return ' 이번 업로드에서 생성된 일부 항목은 정리하지 못했습니다. 목록을 새로고침한 뒤 남은 항목을 확인해주세요.';
        }
        return ' 이번 업로드에서 생성된 항목은 정리했습니다.';
    }

    private async _finishFolderUpload(bestFolderId: string) {
        if (bestFolderId) {
            this.currentFolder = bestFolderId;
            this.showMetaPanel = false;
        }

        try {
            await this.load();

            if (this.currentFolder && this.files.length > 0) {
                await this.generateMetadata(false);
            }
        } catch (e) {
            try {
                await this._showDriveError(
                    '폴더 업로드 후처리 실패',
                    this.getErrorMessage(e, '업로드는 완료됐지만 목록 갱신 또는 자동 분류에 실패했습니다. 새로고침 후 확인해주세요.')
                );
            } catch (_modalError) {
                // 후처리 알림 실패가 업로드 롤백으로 전파되지 않게 막는다.
            }
        }
    }

    public async uploadFiles() {
        let input = document.createElement('input');
        input.type = 'file';
        input.multiple = true;
        input.onchange = async () => {
            if (!input.files || input.files.length === 0) return;

            let uploaded = false;
            try {
                const totalSize = Array.from(input.files).reduce((s, f) => s + f.size, 0);
                this.uploading = true;
                this.uploadPercent = 0;
                this.uploadProgress = `파일 ${input.files.length}개 (${this.formatSize(totalSize)}) 업로드 준비 중...`;
                await this.service.render();

                let fd = new FormData();
                fd.append('folder_id', this.currentFolder);
                for (let i = 0; i < input.files.length; i++) {
                    fd.append('file[]', input.files[i]);
                }

                await this._uploadWithProgress(fd, `파일 ${input.files.length}개`, this.currentFolder);
                uploaded = true;
            } catch (e) {
                this._resetUploadState();
                await this.service.render();
                await this._showDriveError('파일 업로드 실패', this.getErrorMessage(e, '파일 업로드에 실패했습니다.'));
            }

            this._resetUploadState();
            await this.load();

            // 현재 폴더에 파일이 있으면 자동 분류
            if (uploaded && this.currentFolder && this.files.length > 0) {
                await this.generateMetadata(false);
            }
        };
        input.click();
    }

    public async uploadFolder() {
        let input = document.createElement('input');
        input.type = 'file';
        (input as any).webkitdirectory = true;
        input.onchange = async () => {
            if (!input.files || input.files.length === 0) return;

            this.uploading = true;
            this.uploadPercent = 0;
            this.uploadProgress = `폴더 구조 분석 중... (${input.files.length}개 파일)`;
            await this.service.render();

            const pathMap: Map<string, File[]> = new Map();
            const allPaths: Set<string> = new Set();

            for (let i = 0; i < input.files.length; i++) {
                const file = input.files[i];
                const relPath = (file as any).webkitRelativePath || file.name;
                const parts = relPath.split('/');
                const folderPath = parts.slice(0, -1).join('/');

                if (!pathMap.has(folderPath)) pathMap.set(folderPath, []);
                pathMap.get(folderPath)!.push(file);

                for (let j = 1; j <= parts.length - 1; j++) {
                    allPaths.add(parts.slice(0, j).join('/'));
                }
            }

            const sortedPaths = Array.from(allPaths).sort();
            const folderIdMap: Map<string, string> = new Map();
            folderIdMap.set('', this.currentFolder);
            const createdFolders: any[] = [];
            const uploadedFileIds: string[] = [];

            try {
                for (const path of sortedPaths) {
                    const parts = path.split('/');
                    const folderName = parts[parts.length - 1];
                    const parentPath = parts.slice(0, -1).join('/');
                    const parentId = folderIdMap.get(parentPath);
                    if (typeof parentId === 'undefined') {
                        throw new Error(`${path} 생성 실패: 상위 폴더를 확인할 수 없습니다.`);
                    }

                    this.uploadProgress = `폴더 생성: ${path}`;
                    await this.service.render();

                    const res: any = await wiz.call("create_folder", { name: folderName, parent_id: parentId });
                    if (res.code === 200 && res.data?.id) {
                        folderIdMap.set(path, res.data.id);
                        createdFolders.push({ id: res.data.id, path, name: folderName });
                    } else {
                        throw new Error(`${path} 생성 실패: ${this.getResponseMessage(res, '폴더를 만들지 못했습니다.')}`);
                    }
                }

                const totalFiles = input.files.length;
                const totalSize = Array.from(input.files).reduce((s, f) => s + f.size, 0);
                let uploadedFiles = 0;
                let uploadedBytes = 0;

                // 파일이 가장 많이 업로드된 폴더 추적
                let bestFolderId = '';
                let bestFileCount = 0;

                for (const [folderPath, files] of pathMap.entries()) {
                    const targetFolderId = folderIdMap.get(folderPath);
                    if (typeof targetFolderId === 'undefined') {
                        throw new Error(`${folderPath || '루트'} 업로드 실패: 대상 폴더를 확인할 수 없습니다.`);
                    }
                    const batchSize = files.reduce((s, f) => s + f.size, 0);

                    if (files.length > bestFileCount) {
                        bestFileCount = files.length;
                        bestFolderId = targetFolderId;
                    }

                    const fd = new FormData();
                    fd.append('folder_id', targetFolderId);
                    for (const file of files) fd.append('file[]', file);

                    const batchLabel = `${folderPath || '루트'} (${uploadedFiles}/${totalFiles} 파일, ${this.formatSize(uploadedBytes)} / ${this.formatSize(totalSize)})`;
                    try {
                        const res = await this._uploadWithProgress(fd, batchLabel, targetFolderId);
                        uploadedFileIds.push(...this._uploadedIds(res));
                    } catch (e) {
                        throw new Error(`${folderPath || '루트'} 업로드 실패: ${this.getErrorMessage(e, '파일 업로드에 실패했습니다.')}`);
                    }
                    uploadedFiles += files.length;
                    uploadedBytes += batchSize;
                }

                this._resetUploadState();

                await this._finishFolderUpload(bestFolderId);
            } catch (e) {
                this.uploadProgress = '업로드 실패 항목 정리 중...';
                await this.service.render();
                const cleanupFailures = await this._rollbackCreatedUpload(createdFolders, uploadedFileIds);
                const cleanupMessage = this._cleanupMessage(createdFolders, uploadedFileIds, cleanupFailures);
                this._resetUploadState();
                await this.load();
                await this._showDriveError('폴더 업로드 실패', this.getErrorMessage(e, '폴더 업로드에 실패했습니다.') + cleanupMessage);
            }
        };
        input.click();
    }

    public async deleteFile(fileId: string) {
        let res = await this.service.modal.show({ title: "파일 삭제", message: "이 파일을 삭제하시겠습니까?", action: "삭제", actionBtn: "error" });
        if (!res) return;
        await wiz.call("delete_file", { file_id: fileId });
        if (this.previewFile?.id === fileId) this.closePreview();
        await this.load();
    }

    public get missingFileCount(): number {
        return this.files.filter((file: any) => this.isMissingFile(file)).length;
    }

    public async cleanupMissingFiles() {
        if (this.missingFileCount === 0) return;
        const ok = await this.service.modal.show({
            title: '누락 파일 정리',
            message: `현재 목록에서 원본이 없는 파일 기록 ${this.missingFileCount}개를 삭제하시겠습니까?`,
            action: '정리',
            actionBtn: 'error',
        });
        if (!ok) return;
        await wiz.call('cleanup_missing_files', { folder_id: this.currentFolder });
        await this.load();
    }

    public isMissingFile(file: any): boolean {
        return !!file && (file.missing_on_disk === true || file.disk_exists === false || file.downloadable === false);
    }

    private async showMissingFileNotice(file: any) {
        const name = file?.name || '선택한 파일';
        await this.service.modal.show({
            title: '원본 파일 없음',
            message: `${name}의 원본 파일이 서버 디스크에 없습니다. 프로젝트 복사 시 data/drive 폴더가 함께 복사되지 않은 것 같습니다. 파일을 다시 업로드해주세요.`,
            action: '확인',
            cancel: false,
            status: 'warning',
        });
    }

    public async downloadFile(fileOrId: any) {
        const file = typeof fileOrId === 'object'
            ? fileOrId
            : this.files.find((item: any) => item.id === fileOrId);
        const fileId = typeof fileOrId === 'object' ? fileOrId?.id : fileOrId;
        if (!fileId) return;
        if (this.isMissingFile(file)) {
            await this.showMissingFileNotice(file);
            return;
        }
        window.open(`/api/drive/file.download?file_id=${encodeURIComponent(fileId)}`, '_blank');
    }

    public isPreviewableFile(file: any): boolean {
        const name = this.normalizedFileName(file);
        const mimetype = String(file?.mimetype || '').toLowerCase();
        return mimetype.includes('pdf')
            || mimetype.startsWith('image/')
            || mimetype.startsWith('text/')
            || name.endsWith('.pdf')
            || name.endsWith('.txt')
            || name.endsWith('.md')
            || name.endsWith('.csv')
            || name.endsWith('.json');
    }

    public normalizedFileName(file: any): string {
        return String(file?.name || file?.filename || file?.file_name || file?.original_name || '').toLowerCase();
    }

    public isSpreadsheetFile(file: any): boolean {
        const name = this.normalizedFileName(file);
        const mimetype = String(file?.mimetype || '').toLowerCase();
        return mimetype.includes('spreadsheet')
            || mimetype.includes('excel')
            || mimetype.includes('sheet')
            || name.endsWith('.xlsx')
            || name.endsWith('.xlsm')
            || name.endsWith('.xltx')
            || name.endsWith('.xltm')
            || name.endsWith('.xls');
    }

    public isXlsxFile(file: any): boolean {
        const name = this.normalizedFileName(file);
        const mimetype = String(file?.mimetype || '').toLowerCase();
        return name.endsWith('.xlsx')
            || name.endsWith('.xlsm')
            || name.endsWith('.xltx')
            || name.endsWith('.xltm')
            || mimetype.includes('spreadsheetml')
            || mimetype.includes('openxmlformats-officedocument.spreadsheetml');
    }

    public isHwpFile(file: any): boolean {
        const name = this.normalizedFileName(file);
        return name.endsWith('.hwp') || name.endsWith('.hwpx');
    }

    public isPdfFile(file: any): boolean {
        const name = this.normalizedFileName(file);
        const mimetype = String(file?.mimetype || '').toLowerCase();
        return mimetype.includes('pdf') || name.endsWith('.pdf');
    }

    public isSidePreviewableFile(file: any): boolean {
        return this.isPdfFile(file) || this.isSpreadsheetFile(file) || this.isHwpFile(file);
    }

    public previewTypeLabel(file: any): string {
        if (this.isPdfFile(file)) return 'PDF';
        if (this.isSpreadsheetFile(file)) return 'XLSX';
        if (this.isHwpFile(file)) return 'HWP';
        return 'FILE';
    }

    public closePreview() {
        this.previewFile = null;
        this.previewUrl = '';
    }

    public async openPreview(file: any) {
        if (!file?.id) return;
        if (this.isMissingFile(file)) {
            await this.showMissingFileNotice(file);
            return;
        }
        this.previewFile = file;
        const action = this.isPdfFile(file) ? 'file.view' : 'file.preview';
        this.previewUrl = `/api/drive/${action}?file_id=${encodeURIComponent(file.id)}`;
        await this.service.render();
    }

    public isInspectableFile(file: any): boolean {
        if (this.isMissingFile(file)) return false;
        const name = String(file?.name || file?.filename || '').toLowerCase();
        return name.endsWith('.pdf') || name.endsWith('.hwp') || name.endsWith('.hwpx') || name.endsWith('.xlsx') || name.endsWith('.xlsm');
    }

    public get inspectableFiles(): any[] {
        return this.files.filter((file: any) => this.isInspectableFile(file));
    }

    public get hasInspectableFiles(): boolean {
        return this.inspectableFiles.length > 0 || this.fileCount > this.files.length;
    }

    public async openFile(file: any) {
        if (!file?.id) return;
        if (this.editingId === 'file:' + file.id) return;
        if (this.isMissingFile(file)) {
            await this.showMissingFileNotice(file);
            return;
        }

        if (this.isSidePreviewableFile(file)) {
            await this.openPreview(file);
            return;
        }

        if (this.isPreviewableFile(file)) {
            window.open(`/api/drive/file.view?file_id=${encodeURIComponent(file.id)}`, '_blank');
            return;
        }

        await this.service.modal.show({
            title: '미리보기 미지원',
            message: '이 파일 형식은 브라우저 미리보기가 어려워 다운로드로 열겠습니다.',
            action: '다운로드',
            cancel: false,
            status: 'warning',
        });
        await this.downloadFile(file);
    }

    private getResponseMessage(response: any, fallback: string): string {
        if (!response) return fallback;
        if (typeof response === 'string') return response;
        if (response?.data?.message) return response.data.message;
        if (response?.message) return response.message;
        try {
            const text = JSON.stringify(response);
            return text && text !== '{}' ? text : fallback;
        } catch (e) {
            return fallback;
        }
    }

    private getErrorMessage(error: any, fallback: string): string {
        if (!error) return fallback;
        if (typeof error === 'string') return error;
        if (error?.data?.message) return error.data.message;
        if (error?.responseJSON?.data?.message) return error.responseJSON.data.message;
        if (error?.responseJSON?.message) return error.responseJSON.message;
        const responseMessage = this.getResponseMessage(error, '');
        if (responseMessage) return responseMessage;
        if (error?.message) return error.message;
        try {
            const text = JSON.stringify(error);
            return text && text !== '{}' ? text : fallback;
        } catch (e) {
            return fallback;
        }
    }

    private _currentFolderName(): string {
        if (this.breadcrumb.length > 0) {
            return this.breadcrumb[this.breadcrumb.length - 1].name || '홈';
        }
        return '홈';
    }

    private _resetInspectionSelector() {
        this.showInspectionSelector = false;
        this.inspectionCandidates = [];
        this.inspectionSelection = {};
        this.inspectionCandidatePolicy = null;
    }

    private _applyInspectionDefaults(candidates: any[] = []) {
        const selection: any = {};
        for (const item of candidates) {
            if (!item?.id) continue;
            selection[item.id] = item.default_selected === true;
        }
        this.inspectionSelection = selection;
    }

    public get selectedInspectionCount(): number {
        return this.inspectionCandidates.filter((item: any) => this.inspectionSelection[item.id] === true).length;
    }

    public get selectedInspectionFileIds(): string[] {
        return this.inspectionCandidates
            .filter((item: any) => this.inspectionSelection[item.id] === true)
            .map((item: any) => item.id)
            .filter((id: string) => !!id);
    }

    public get inspectionPolicyText(): string {
        const policy = this.inspectionCandidatePolicy || {};
        const candidateCount = policy.candidate_count || this.inspectionCandidates.length || 0;
        const defaultCount = policy.default_count || 0;
        const reportCount = policy.report_count || 0;

        if (!policy.metadata_present) {
            return `메타데이터가 없어 검사 가능 파일 ${candidateCount}개를 표시합니다. 기본 선택 없이 필요한 파일을 직접 선택하세요.`;
        }
        if (reportCount === 0) {
            return `메타데이터는 있지만 role=report 파일이 없습니다. 검사할 파일을 직접 선택하세요.`;
        }
        if (defaultCount === 0) {
            return `role=report 파일 ${reportCount}개가 있지만 기본 선택할 최신 보고서를 확정하지 못했습니다. 검사할 파일을 직접 선택하세요.`;
        }
        const latestName = policy.latest_report_name ? ` (${policy.latest_report_name})` : '';
        return `role=report 파일 ${reportCount}개 중 수정일자가 가장 최신인 보고서${latestName}를 기본 선택했습니다.`;
    }

    public get inspectionDuplicateText(): string {
        const count = this.inspectionCandidatePolicy?.duplicate_suppressed_count || 0;
        if (!count) return '';
        return `같은 basename의 PDF가 있는 HWP/HWPX ${count}개는 기본 선택에서 제외했습니다.`;
    }

    public inspectionRoleLabel(role: string): string {
        return role ? this.roleLabel(role) : '미분류';
    }

    public inspectionRoleColor(role: string): string {
        return role ? this.roleColor(role) : 'bg-gray-100 text-gray-600';
    }

    public setInspectionSelected(fileId: string, selected: boolean) {
        if (!fileId) return;
        this.inspectionSelection[fileId] = selected === true;
    }

    public async selectAllInspectionCandidates() {
        for (const item of this.inspectionCandidates) {
            if (item?.id) this.inspectionSelection[item.id] = true;
        }
        await this.service.render();
    }

    public async clearInspectionCandidates() {
        for (const item of this.inspectionCandidates) {
            if (item?.id) this.inspectionSelection[item.id] = false;
        }
        await this.service.render();
    }

    public async resetInspectionDefaults() {
        this._applyInspectionDefaults(this.inspectionCandidates);
        await this.service.render();
    }

    public async closeInspectionSelector() {
        this._resetInspectionSelector();
        await this.service.render();
    }

    public async confirmInspectionSelection() {
        const fileIds = this.selectedInspectionFileIds;
        if (fileIds.length === 0) {
            await this.service.modal.show({
                title: '검사 파일 없음',
                message: '검사할 파일을 하나 이상 선택해주세요.',
                action: '확인',
                cancel: false,
                status: 'warning',
            });
            return;
        }
        this.showInspectionSelector = false;
        await this._createInspection(fileIds);
    }

    private async _createInspection(fileIds: string[]) {
        if (this.creatingInspection) return;
        if (fileIds.length === 0) {
            await this.service.modal.show({
                title: '검사 파일 없음',
                message: '검사할 PDF/HWP/HWPX/Excel 파일이 없습니다.',
                action: '확인',
                cancel: false,
                status: 'warning',
            });
            return;
        }

        this.creatingInspection = true;
        await this.service.render();

        try {
            const res: any = await wiz.call('create_inspection_from_drive', {
                folder_id: this.currentFolder,
                folder_name: this._currentFolderName(),
                file_ids: JSON.stringify(fileIds),
            });

            if (res.code === 200 && res.data?.session_id) {
                this.service.href(`/chatbot/room/${res.data.session_id}`);
                return;
            }

            await this.service.modal.show({
                title: '검사 시작 실패',
                message: res.data?.message || '검사 세션을 만들지 못했습니다.',
                action: '확인',
                cancel: false,
                status: 'error',
            });
        } catch (e) {
            await this.service.modal.show({
                title: '검사 시작 실패',
                message: this.getErrorMessage(e, '검사 세션을 만들지 못했습니다.'),
                action: '확인',
                cancel: false,
                status: 'error',
            });
        }

        this.creatingInspection = false;
        await this.service.render();
    }

    public async startInspectionFromFolder() {
        if (this.creatingInspection) return;
        this.creatingInspection = true;
        await this.service.render();

        try {
            const res: any = await wiz.call('get_inspection_candidates', {
                folder_id: this.currentFolder,
            });

            if (res.code !== 200) {
                await this.service.modal.show({
                    title: '검사 대상 확인 실패',
                    message: res.data?.message || '검사 대상 파일을 확인하지 못했습니다.',
                    action: '확인',
                    cancel: false,
                    status: 'error',
                });
                return;
            }

            const candidates = Array.isArray(res.data?.candidates) ? res.data.candidates : [];
            if (candidates.length === 0) {
                await this.service.modal.show({
                    title: '검사 파일 없음',
                    message: '검사할 PDF/HWP/HWPX/Excel 파일이 없습니다.',
                    action: '확인',
                    cancel: false,
                    status: 'warning',
                });
                return;
            }

            this.inspectionCandidates = candidates;
            this.inspectionCandidatePolicy = res.data?.policy || {};
            this._applyInspectionDefaults(candidates);
            this.showInspectionSelector = true;
        } catch (e) {
            await this.service.modal.show({
                title: '검사 대상 확인 실패',
                message: this.getErrorMessage(e, '검사 대상 파일을 확인하지 못했습니다.'),
                action: '확인',
                cancel: false,
                status: 'error',
            });
        } finally {
            this.creatingInspection = false;
            await this.service.render();
        }
    }

    public async startInspectionFromFile(file: any) {
        if (this.isMissingFile(file)) {
            await this.showMissingFileNotice(file);
            return;
        }
        if (!this.isInspectableFile(file)) {
            await this.service.modal.show({
                title: '검사 불가 파일',
                message: '검사는 PDF, HWP, HWPX, Excel 파일만 지원합니다.',
                action: '확인',
                cancel: false,
                status: 'warning',
            });
            return;
        }
        await this._createInspection([file.id]);
    }

    public async createSampleDataset() {
        if (this.creatingDataset) return;
        this.creatingDataset = true;
        await this.service.render();

        try {
            const res: any = await wiz.call('create_sample_dataset');
            if (res.code === 200) {
                const folders = res.data?.folders || [];
                if (folders.length > 0) {
                    const targetFolder = folders.reduce((best: any, folder: any) => {
                        return (folder.file_count || 0) > (best.file_count || 0) ? folder : best;
                    }, folders[0]);
                    this.currentFolder = targetFolder.id;
                    this.page = 1;
                    this.searchText = '';
                    this.showMetaPanel = false;
                    this.editingServiceName = false;
                }
                await this.load();
                await this.service.modal.show({
                    title: '검사용 데이터셋 생성',
                    message: `폴더 ${res.data?.folder_count || folders.length}개, 파일 ${res.data?.file_count || 0}개를 준비했습니다.`,
                    action: '확인',
                    cancel: false,
                    status: 'success',
                });
                this.creatingDataset = false;
                await this.service.render();
                return;
            }

            await this.service.modal.show({
                title: '데이터셋 생성 실패',
                message: res.data?.message || '검사용 데이터셋을 만들지 못했습니다.',
                action: '확인',
                cancel: false,
                status: 'error',
            });
        } catch (e) {
            await this.service.modal.show({
                title: '데이터셋 생성 실패',
                message: this.getErrorMessage(e, '검사용 데이터셋을 만들지 못했습니다.'),
                action: '확인',
                cancel: false,
                status: 'error',
            });
        }

        this.creatingDataset = false;
        await this.service.render();
    }

    // ── 메타데이터 ──

    public async generateMetadata(showPanel: boolean = true) {
        if (!this.currentFolder || this.generatingMeta) return;
        this.generatingMeta = true;
        this.metaProgress = '파일 정보 수집 중...';
        this.metaPercent = 10;
        await this.service.render();

        await new Promise(r => setTimeout(r, 300));
        this.metaProgress = `AI 파일 분류 분석 중... (${this.files.length}개 파일)`;
        this.metaPercent = 25;
        await this.service.render();

        const progressTimer = setInterval(async () => {
            if (this.metaPercent < 85) {
                this.metaPercent += Math.floor(Math.random() * 8) + 2;
                if (this.metaPercent > 85) this.metaPercent = 85;
                await this.service.render();
            }
        }, 600);

        try {
            const res: any = await wiz.call("generate_metadata", { folder_id: this.currentFolder });
            clearInterval(progressTimer);

            if (res.code === 200 && res.data?.metadata) {
                this.metadata = res.data.metadata;
                this.serviceName = this.metadata?.service_name || '';
                this.metaPercent = 100;
                this.metaProgress = '분류 완료!';
                await this.service.render();
                await new Promise(r => setTimeout(r, 800));
                if (showPanel) this.showMetaPanel = true;
            } else {
                this.metaProgress = '분류 실패';
                this.metaPercent = 0;
                await this.service.render();
                await new Promise(r => setTimeout(r, 1500));
            }
        } catch (e) {
            clearInterval(progressTimer);
            this.metaProgress = '분류 실패';
            this.metaPercent = 0;
            await this.service.render();
            await new Promise(r => setTimeout(r, 1500));
        }

        this.generatingMeta = false;
        this.metaProgress = '';
        this.metaPercent = 0;
        await this.service.render();
    }

    public async updateFileRole(fileId: string, role: string) {
        if (!this.currentFolder) return;
        await wiz.call("update_file_role", { folder_id: this.currentFolder, file_id: fileId, role: role });
        if (this.metadata?.files) {
            for (const f of this.metadata.files) {
                if (f.id === fileId) {
                    f.role = role;
                    break;
                }
            }
        }
        await this.service.render();
    }

    public async updateFolderRole(role: string) {
        if (!this.currentFolder || !role) return;
        const ok = await this.service.modal.show({
            title: '폴더 역할 일괄 적용',
            message: `현재 폴더의 파일 역할을 모두 '${this.roleLabel(role)}'로 변경하시겠습니까?`,
            action: '적용',
            status: 'warning',
        });
        if (!ok) return;
        const res: any = await wiz.call("update_folder_role", { folder_id: this.currentFolder, role });
        if (res.code === 200 && res.data?.metadata) {
            this.metadata = res.data.metadata;
            this.serviceName = this.metadata?.service_name || this.serviceName;
        }
        await this.service.render();
    }

    public getFileRole(fileId: string): string {
        if (!this.metadata?.files) return '';
        const f = this.metadata.files.find((m: any) => m.id === fileId);
        return f?.role || '';
    }

    public getFileDescription(fileId: string): string {
        if (!this.metadata?.files) return '';
        const f = this.metadata.files.find((m: any) => m.id === fileId);
        return f?.description || '';
    }

    public toggleMetaPanel() {
        this.showMetaPanel = !this.showMetaPanel;
    }

    public roleLabel(role: string): string {
        const normalized = this.normalizeRole(role);
        const labels: any = { report: '보고서', '부록': '부록', appendix: '부록', contract: '계약서', kickoff: '착수계', ledger: '관리대장', other: '기타' };
        return labels[normalized] || normalized;
    }

    public roleColor(role: string): string {
        const normalized = this.normalizeRole(role);
        const colors: any = {
            report: 'bg-blue-100 text-blue-700',
            '부록': 'bg-yellow-100 text-yellow-700',
            appendix: 'bg-yellow-100 text-yellow-700',
            contract: 'bg-amber-100 text-amber-700',
            kickoff: 'bg-emerald-100 text-emerald-700',
            ledger: 'bg-purple-100 text-purple-700',
            other: 'bg-gray-100 text-gray-600'
        };
        return colors[normalized] || 'bg-gray-100 text-gray-600';
    }

    public normalizeRole(role: string): string {
        const text = String(role || '').trim().toLowerCase();
        if (!text) return '';
        if (['appendix', '부록', '부록자료', '첨부', '첨부자료', '별첨'].includes(text)) return '부록';
        if (['additional', 'other', '기타'].includes(text)) return 'other';
        if (text === '보고서') return 'report';
        if (text === '계약서') return 'contract';
        if (text === '착수계') return 'kickoff';
        if (text === '관리대장') return 'ledger';
        return text;
    }

    public countByRole(role: string): number {
        if (!this.metadata?.files) return 0;
        const normalized = this.normalizeRole(role);
        return this.metadata.files.filter((f: any) => this.normalizeRole(f.role) === normalized).length;
    }

    // ── 검색 ──

    public async search() { this.page = 1; await this.load(); }
    public async clearSearch() { this.searchText = ''; this.page = 1; await this.load(); }

    // ── 포맷 ──

    public formatSize(bytes: number): string {
        if (!bytes) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB'];
        let i = 0;
        let size = bytes;
        while (size >= 1024 && i < units.length - 1) { size /= 1024; i++; }
        return size.toFixed(i === 0 ? 0 : 1) + ' ' + units[i];
    }

    // ── 페이지네이션 ──

    public get totalPages(): number { return Math.ceil(this.fileCount / this.dump); }

    public async goPage(p: number) {
        if (p < 1 || p > this.totalPages) return;
        this.page = p;
        await this.load();
    }

    // ── Drag & Drop ──

    private _targetKey(folderId: string): string {
        return folderId || '__root__';
    }

    private _canDropItemToFolder(item: any, folderId: string): boolean {
        if (!item || !item.id || !item.type) return false;
        const targetFolderId = folderId || '';
        if (this.currentFolder === targetFolderId) return false;
        if (item.type === 'folder' && item.id === targetFolderId) return false;
        return true;
    }

    private _readDragItem(event: any): any {
        if (this.draggingItem) return this.draggingItem;
        const data = event?.dataTransfer?.getData(this.driveDragMime);
        if (!data) return null;
        try {
            return JSON.parse(data);
        } catch (e) {
            return null;
        }
    }

    private _clearDragState() {
        this.draggingItem = null;
        this.dragOverFolderId = '';
    }

    public canDropToFolderId(folderId: string): boolean {
        return this._canDropItemToFolder(this.draggingItem, folderId);
    }

    public isMoveTargetActive(folderId: string): boolean {
        return this.dragOverFolderId === this._targetKey(folderId) && this.canDropToFolderId(folderId);
    }

    public isDragging(type: string, id: string): boolean {
        return !!this.draggingItem && this.draggingItem.type === type && this.draggingItem.id === id;
    }

    public onItemDragStart(event: any, type: string, item: any) {
        if (!item?.id || this.editingId === type + ':' + item.id || this.movingItem) {
            event.preventDefault();
            return;
        }

        const payload = { type, id: item.id, name: item.name || '' };
        this.draggingItem = payload;
        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData(this.driveDragMime, JSON.stringify(payload));
            event.dataTransfer.setData('text/plain', `${type}:${item.id}`);
        }
        this.service.render();
    }

    public onItemDragEnd(event: any) {
        this._clearDragState();
        this.service.render();
    }

    public onMoveTargetDragOver(event: any, folderId: string) {
        if (!this.canDropToFolderId(folderId)) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';

        const targetKey = this._targetKey(folderId);
        if (this.dragOverFolderId !== targetKey) {
            this.dragOverFolderId = targetKey;
            this.service.render();
        }
    }

    public onMoveTargetDragLeave(event: any, folderId: string) {
        const current = event.currentTarget;
        const next = event.relatedTarget;
        if (current && next && current.contains(next)) return;

        if (this.dragOverFolderId === this._targetKey(folderId)) {
            this.dragOverFolderId = '';
            this.service.render();
        }
    }

    public async onMoveTargetDrop(event: any, folderId: string) {
        const item = this._readDragItem(event);
        if (!item) return;

        event.preventDefault();
        event.stopPropagation();

        if (!this._canDropItemToFolder(item, folderId)) {
            this._clearDragState();
            await this.service.render();
            return;
        }

        this.movingItem = true;
        this.dragOverFolderId = '';
        await this.service.render();

        try {
            const res: any = await wiz.call('move_item', {
                item_type: item.type,
                item_id: item.id,
                target_folder_id: folderId || ''
            });

            if (res.code === 200) {
                await this.load();
            } else {
                await this.service.modal.show({
                    title: '이동 실패',
                    message: res.data?.message || '항목을 이동하지 못했습니다.',
                    action: '확인',
                    cancel: false,
                    status: 'error',
                });
            }
        } catch (e) {
            await this.service.modal.show({
                title: '이동 실패',
                message: this.getErrorMessage(e, '항목을 이동하지 못했습니다.'),
                action: '확인',
                cancel: false,
                status: 'error',
            });
        }

        this.movingItem = false;
        this._clearDragState();
        await this.service.render();
    }

    public async onDrop(event: any) {
        event.preventDefault();
        const draggedItem = this._readDragItem(event);
        if (draggedItem) {
            this._clearDragState();
            await this.service.render();
            return;
        }

        const dt = event.dataTransfer;
        if (!dt) return;

        if (dt.items && dt.items.length > 0) {
            const entries: any[] = [];
            for (let i = 0; i < dt.items.length; i++) {
                const entry = dt.items[i].webkitGetAsEntry?.();
                if (entry) entries.push(entry);
            }
            if (entries.some((e: any) => e.isDirectory)) {
                await this._handleDirectoryDrop(entries);
                return;
            }
        }

        if (dt.files && dt.files.length > 0) {
            let uploaded = false;
            try {
                const totalSize = Array.from(dt.files as FileList).reduce((s: number, f: File) => s + f.size, 0);
                this.uploading = true;
                this.uploadPercent = 0;
                this.uploadProgress = `파일 ${dt.files.length}개 (${this.formatSize(totalSize)}) 업로드 준비 중...`;
                await this.service.render();

                let fd = new FormData();
                fd.append('folder_id', this.currentFolder);
                for (let i = 0; i < dt.files.length; i++) fd.append('file[]', dt.files[i]);

                await this._uploadWithProgress(fd, `파일 ${dt.files.length}개`, this.currentFolder);
                uploaded = true;
            } catch (e) {
                this._resetUploadState();
                await this.service.render();
                await this._showDriveError('파일 업로드 실패', this.getErrorMessage(e, '파일 업로드에 실패했습니다.'));
            }

            this._resetUploadState();
            await this.load();

            if (uploaded && this.currentFolder && this.files.length > 0) {
                await this.generateMetadata(false);
            }
        }
    }

    private async _handleDirectoryDrop(entries: any[]) {
        this.uploading = true;
        this.uploadPercent = 0;
        this.uploadProgress = '드롭된 폴더 구조 분석 중...';
        await this.service.render();

        const fileEntries: { path: string; file: File }[] = [];
        const allFolderPaths: Set<string> = new Set();

        const readEntry = (entry: any, path: string): Promise<void> => {
            return new Promise((resolve) => {
                if (entry.isFile) {
                    entry.file((file: File) => { fileEntries.push({ path, file }); resolve(); });
                } else if (entry.isDirectory) {
                    allFolderPaths.add(path + entry.name);
                    const reader = entry.createReader();
                    reader.readEntries(async (children: any[]) => {
                        for (const child of children) await readEntry(child, path + entry.name + '/');
                        resolve();
                    });
                } else { resolve(); }
            });
        };

        for (const entry of entries) await readEntry(entry, '');

        if (fileEntries.length === 0) {
            this._resetUploadState();
            await this.service.render();
            return;
        }

        for (const fe of fileEntries) {
            const parts = fe.path.split('/').filter((p: string) => p);
            for (let j = 1; j <= parts.length; j++) allFolderPaths.add(parts.slice(0, j).join('/'));
        }

        const sortedPaths = Array.from(allFolderPaths).sort();
        const folderIdMap: Map<string, string> = new Map();
        folderIdMap.set('', this.currentFolder);
        const createdFolders: any[] = [];
        const uploadedFileIds: string[] = [];

        try {
            for (const path of sortedPaths) {
                const parts = path.split('/');
                const folderName = parts[parts.length - 1];
                const parentPath = parts.slice(0, -1).join('/');
                const parentId = folderIdMap.get(parentPath);
                if (typeof parentId === 'undefined') {
                    throw new Error(`${path} 생성 실패: 상위 폴더를 확인할 수 없습니다.`);
                }

                this.uploadProgress = `폴더 생성: ${path}`;
                await this.service.render();

                const res: any = await wiz.call("create_folder", { name: folderName, parent_id: parentId });
                if (res.code === 200 && res.data?.id) {
                    folderIdMap.set(path, res.data.id);
                    createdFolders.push({ id: res.data.id, path, name: folderName });
                } else {
                    throw new Error(`${path} 생성 실패: ${this.getResponseMessage(res, '폴더를 만들지 못했습니다.')}`);
                }
            }

            const pathFileMap: Map<string, File[]> = new Map();
            for (const fe of fileEntries) {
                const folderPath = fe.path.replace(/\/$/, '');
                if (!pathFileMap.has(folderPath)) pathFileMap.set(folderPath, []);
                pathFileMap.get(folderPath)!.push(fe.file);
            }

            const totalSize = fileEntries.reduce((s, fe) => s + fe.file.size, 0);
            let uploadedFiles = 0;
            let uploadedBytes = 0;
            let bestFolderId = '';
            let bestFileCount = 0;

            for (const [folderPath, files] of pathFileMap.entries()) {
                const targetFolderId = folderIdMap.get(folderPath);
                if (typeof targetFolderId === 'undefined') {
                    throw new Error(`${folderPath || '루트'} 업로드 실패: 대상 폴더를 확인할 수 없습니다.`);
                }
                const batchSize = files.reduce((s, f) => s + f.size, 0);

                if (files.length > bestFileCount) {
                    bestFileCount = files.length;
                    bestFolderId = targetFolderId;
                }

                const fd = new FormData();
                fd.append('folder_id', targetFolderId);
                for (const file of files) fd.append('file[]', file);

                const batchLabel = `${folderPath || '루트'} (${uploadedFiles}/${fileEntries.length} 파일, ${this.formatSize(uploadedBytes)} / ${this.formatSize(totalSize)})`;
                try {
                    const res = await this._uploadWithProgress(fd, batchLabel, targetFolderId);
                    uploadedFileIds.push(...this._uploadedIds(res));
                } catch (e) {
                    throw new Error(`${folderPath || '루트'} 업로드 실패: ${this.getErrorMessage(e, '파일 업로드에 실패했습니다.')}`);
                }
                uploadedFiles += files.length;
                uploadedBytes += batchSize;
            }

            this._resetUploadState();

            await this._finishFolderUpload(bestFolderId);
        } catch (e) {
            this.uploadProgress = '업로드 실패 항목 정리 중...';
            await this.service.render();
            const cleanupFailures = await this._rollbackCreatedUpload(createdFolders, uploadedFileIds);
            const cleanupMessage = this._cleanupMessage(createdFolders, uploadedFileIds, cleanupFailures);
            this._resetUploadState();
            await this.load();
            await this._showDriveError('폴더 업로드 실패', this.getErrorMessage(e, '폴더 업로드에 실패했습니다.') + cleanupMessage);
        }
    }

    public onDragOver(event: any) {
        event.preventDefault();
        if (event.dataTransfer) {
            event.dataTransfer.dropEffect = this.draggingItem ? 'move' : 'copy';
        }
    }
}

export default PageDriveComponent;